export default {
  // mainAPI: 'https://www.fotopostapp.ru',
  mainAPI: process.env.NODE_ENV !== 'production' ? 'http://qa.fotopostapp.com' : '',
  PRODUCTS: '/api/product-catalog/',
  fotoPath: '/api/products/?category=photos',
  deliveryPath: '/api/delivery_types/',
  deliveryPathPrices: '/api/delivery_types_prices/',
  orderPrice: '/api/order/prices/',
  newOrder: '/api/order/prepare/',
  pictToOrder: '/api/order/',
  checkPromoCodeSeparatly: '/api/promo/',
  uploadPicture: '/api/order/photo/add/',
};
